import React from 'react';

const SvgIcon = () => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
   width="24px" height="24px" viewBox="0 0 512.000000 512.000000"
   preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill="#000000" stroke="none">
      <path d="M2315 5109 c-597 -61 -1141 -318 -1563 -739 -1002 -1000 -1002 -2620
      0 -3620 407 -405 900 -647 1493 -732 119 -17 512 -16 635 1 581 80 1087 329
      1490 733 463 464 722 1060 747 1718 26 710 -243 1394 -748 1899 -396 396 -891
      644 -1454 727 -122 18 -477 26 -600 13z m570 -414 c606 -94 1138 -434 1475
      -943 400 -602 470 -1375 187 -2036 -299 -697 -917 -1175 -1672 -1293 -149 -24
      -487 -23 -634 0 -952 154 -1670 872 -1818 1822 -24 151 -24 479 0 630 96 613
      429 1140 936 1479 302 202 634 319 1026 360 81 8 403 -4 500 -19z"/>
      <path d="M1718 3461 c-79 -50 -113 -172 -72 -254 9 -18 154 -170 322 -339
      l307 -308 -307 -307 c-168 -170 -313 -322 -322 -340 -40 -79 -7 -202 66 -251
      52 -34 148 -43 199 -17 19 9 172 155 341 323 l308 307 307 -307 c170 -168 323
      -314 342 -323 51 -26 147 -17 199 17 73 49 106 172 66 251 -9 18 -154 170
      -322 340 l-307 307 307 308 c168 169 313 321 322 339 40 79 7 202 -66 251 -52
      34 -148 43 -199 17 -19 -9 -172 -155 -342 -323 l-307 -307 -308 307 c-169 168
      -321 313 -339 322 -18 9 -57 16 -91 16 -47 0 -67 -6 -104 -29z"/>
    </g>
  </svg>
);

export default SvgIcon;
